@if (permDir.uipermission() !== PERMISSIONS.NONE || permDir.editPermissions()) {
  <!-- Section Group Header -->
  <div
    [class]="headerCssClass()"
    [attr.uisectiongroupheader]="
      settings().isMinimized ? 'collapsed' : 'expanded'
    "
    [style.display]="
      settings().hideLabel || !settings().label ? 'none' : 'flex'
    "
    (click)="settings().canMinimize ? toggle() : undefined"
  >
    @if (settings().canMinimize) {
      <icon
        uisectiongroupdefaulticon
        [iconDefinition]="
          settings().isMinimized ? ICONS.CHEVRON_DOWN : ICONS.CHEVRON_UP
        "
      ></icon>
    }

    <ng-content select="[uisectiongroupiconleft]"></ng-content>

    <span uisectiongrouptitle [UiCopy]="settings().label!">
      {{ settings().label }}
    </span>

    <ng-content select="[uisectiongroupicon]"></ng-content>
    <span uispacer></span>

    <!-- Section Group Tools -->
    <div uitoolstrip>
      <ng-content select="[uisectiongrouptool]"></ng-content>
    </div>
  </div>

  <!-- Section Group Content -->
  @if (!settings().isMinimized) {
    @if (contentDir.uicontentcomponent()) {
      <ng-template
        *ngComponentOutlet="
          contentDir.uicontentcomponent();
          inputs: contentDir.uicontentinput()
        "
      ></ng-template>
    } @else if (settings().useRouterOutlet) {
      <router-outlet class="hidden"></router-outlet>
    } @else if (settings().useNgContent) {
      <ng-content select="div[uisectiongroupcontent]"></ng-content>
    } @else {
      <div
        uisectiongroupcontent
        [class]="contentCssClass()"
        [uiloading]="loadingDir.uiloading()"
      >
        <ng-content></ng-content>
      </div>
    }
  }
}
